import { render, staticRenderFns } from "./activityCollections.vue?vue&type=template&id=0d06a5d1"
import script from "./activityCollections.vue?vue&type=script&lang=js"
export * from "./activityCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports